// base_info_view_4_2
import React, { useRef, useState, useEffect } from 'react'
import { Select } from './ot'
import { ArrowDownAZ, ArrowDownZA } from 'lucide-react';

const BaseInfoView4_2 = ({
    value = null,
    onChange = () => { },
    defaultValue = null,
    placeholder = "請選擇排序",
    orderColumns = [
        {
            label: "年齡",
            value: "age"
        },
        {
            label: "姓名",
            value: "name"
        }
    ],
}) => {
    const getOrderOption = (columns) => {
        let options = []
        columns?.forEach(element => {
            options.push({
                label:   element?.label + "-升序",
                value: element?.value + "-ASC"
            })
            options.push({
                label:  element?.label + "-降序",
                value: element?.value + "-DESC"
            })
        });
        return options
    }
    return (<Select
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        options={getOrderOption(orderColumns)}
        onChange={onChange}
    />)
}
export default BaseInfoView4_2
